import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5a4921a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "conversations"
}

import ConversationChat from './ConversationChat.vue';
import { useAuth } from '@/store/useAuth';
import { useConversations } from '@/store/useConversations';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversationsBar',
  setup(__props) {

const storeConversation = useConversations()
const store = useAuth()


return (_ctx: any,_cache: any) => {
  return (_unref(store).token)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storeConversation).conversations, (conversation, index) => {
          return (_openBlock(), _createBlock(ConversationChat, {
            key: index,
            conversation: conversation
          }, null, 8, ["conversation"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})